import { Component, OnInit } from '@angular/core';
import { Globals } from 'app/_globals';

@Component({
  selector: 'admin-users',
  templateUrl: './admin-users.component.html',
  styles: []
})
export class AdminUsersComponent implements OnInit {

  public routeRole;

  constructor(
    public globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
  }
}
